export { getPciPalAgentCookie } from './pciPalAgentCookie';
